import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const GrapheditGlyph = /*#__PURE__*/createElement("g", {
  id: "Graphic_editor"
}, /*#__PURE__*/createElement("circle", {
  cx: "60.89",
  cy: "31.44",
  r: "6.67"
}), /*#__PURE__*/createElement("path", {
  d: "M73.94,67H10.06 c-0.77,0-1.39-0.62-1.39-1.39V18.39c0-0.77,0.62-1.39,1.39-1.39h63.89c0.77,0,1.39,0.62,1.39,1.39v47.22 C75.33,66.38,74.71,67,73.94,67z M11.44,64.22h61.11V19.78H11.44V64.22z",
  strokeWidth: "0.25",
  strokeMiterlimit: "10"
}), /*#__PURE__*/createElement("path", {
  d: "M57.44,56.51L40.87,35.13c-0.26-0.33-0.64-0.51-1.07-0.52c-0.42,0-0.81,0.2-1.06,0.53l-3.78,5.03 l-7.48-9.34c-0.31-0.38-0.79-0.57-1.27-0.48c-0.48,0.08-0.88,0.42-1.03,0.89c-8.62,25.34-8.62,25.81-8.62,26.09 c0,0.74,0.6,1.34,1.34,1.34h38.49c0.51,0,0.98-0.29,1.2-0.75C57.81,57.46,57.75,56.91,57.44,56.51z"
}));
const Graphedit = createSvg({
  name: 'graphedit',
  path: GrapheditGlyph
});

export default Graphedit;
export { GrapheditGlyph };
